









import { Component, Prop, Vue } from "vue-property-decorator";
import { Section } from "@/types/section";
import SectionRow from "@/components/SectionRow.vue";
import Spacer from "@/components/Spacer.vue";

@Component({
  components: {
    SectionRow,
    Spacer
  }
})
export default class SectionItem extends Vue {
  @Prop({ type: Object, required: true }) private section!: Section;
}
